export default __webpack_public_path__ + "static/media/laundry2-afterB-768w.08d320f3.avif";